// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   Imergey Admin — Bold Rebrand Theme Layer
   Imported LAST so it wins over main.css / responsive.css.
   Phase 0: global base (typography, surfaces, focus, motion library).
   ===================================================================== */

/* ----------------------------- Base ----------------------------- */
body {
  background-color: var(--bg-app) !important;
  color: var(--text-secondary);
  font-family: var(--font-sans) !important;
  font-size: var(--fs-base);
  line-height: var(--lh-normal);
  letter-spacing: -0.011em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

body,
button,
input,
select,
textarea,
.ant-layout,
.ant-btn,
.ant-input,
.ant-select,
.ant-menu,
.ant-table,
.ant-modal,
.ant-form,
.ant-typography {
  font-family: var(--font-sans) !important;
}

h1, h2, h3, h4, h5, h6,
.ant-typography h1, .ant-typography h2, .ant-typography h3,
.ant-page-header-heading-title,
.ime-display {
  font-family: var(--font-display) !important;
  color: var(--text-primary);
  font-weight: var(--fw-bold);
  letter-spacing: -0.02em;
  line-height: var(--lh-tight);
}

a {
  color: var(--brand-600);
  transition: color var(--dur-fast) var(--ease-out);
}
a:hover {
  color: var(--brand-700);
}

::selection {
  background: var(--brand-200);
  color: var(--brand-900);
}

.ant-avatar {
  background: var(--brand-gradient) !important;
  font-family: var(--font-display) !important;
  font-weight: var(--fw-semibold);
}

/* ----------------------------- Scrollbar ----------------------------- */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--n-300) transparent;
}
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background: var(--n-300);
  border-radius: var(--r-full);
  border: 2px solid transparent;
  background-clip: content-box;
}
*::-webkit-scrollbar-thumb:hover {
  background: var(--n-400);
  background-clip: content-box;
}

/* ----------------------------- Focus ring (a11y) ----------------------------- */
a:focus-visible,
button:focus-visible,
.ant-btn:focus-visible,
.ant-input:focus-visible,
.ant-select-selector:focus-visible,
[tabindex]:focus-visible {
  outline: 2px solid var(--brand-500);
  outline-offset: 2px;
  border-radius: var(--r-sm);
}

/* =====================================================================
   Motion library — keyframes + utility classes
   ===================================================================== */
@keyframes ime-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}
@keyframes ime-fade-in-up {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes ime-fade-in-down {
  from { opacity: 0; transform: translateY(-12px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes ime-scale-in {
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1); }
}
@keyframes ime-shimmer {
  0%   { background-position: -468px 0; }
  100% { background-position: 468px 0; }
}
@keyframes ime-spin {
  to { transform: rotate(360deg); }
}
@keyframes ime-pulse {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.5; }
}
@keyframes ime-pop {
  0%   { transform: scale(0.8); opacity: 0; }
  60%  { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(1); }
}

.ime-fade-in      { animation: ime-fade-in var(--dur-base) var(--ease-out) both; }
.ime-fade-in-up   { animation: ime-fade-in-up var(--dur-slow) var(--ease-out) both; }
.ime-fade-in-down { animation: ime-fade-in-down var(--dur-slow) var(--ease-out) both; }
.ime-scale-in     { animation: ime-scale-in var(--dur-base) var(--ease-spring) both; }

.ime-stagger > * {
  animation: ime-fade-in-up var(--dur-slow) var(--ease-out) both;
  animation-delay: calc(var(--i, 0) * 60ms);
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/theme.css"],"names":[],"mappings":"AAAA;;;;0EAI0E;;AAE1E,qEAAqE;AACrE;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;;;;;;;;;;;;;;EAcE,wCAAwC;AAC1C;;AAEA;;;;EAIE,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;AACnD;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA,0EAA0E;AAC1E;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,kFAAkF;AAClF;;;;;;EAME,mCAAmC;EACnC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;0EAE0E;AAC1E;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;AACA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,4BAA4B,EAAE;AACvC;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,YAAY,EAAE;AAC3B;AACA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,oBAAoB,2DAA2D,EAAE;AACjF,oBAAoB,8DAA8D,EAAE;AACpF,oBAAoB,gEAAgE,EAAE;AACtF,oBAAoB,+DAA+D,EAAE;;AAErF;EACE,8DAA8D;EAC9D,yCAAyC;AAC3C;;AAEA;EACE;;;IAGE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;IACvC,gCAAgC;EAClC;AACF","sourcesContent":["/* =====================================================================\n   Imergey Admin — Bold Rebrand Theme Layer\n   Imported LAST so it wins over main.css / responsive.css.\n   Phase 0: global base (typography, surfaces, focus, motion library).\n   ===================================================================== */\n\n/* ----------------------------- Base ----------------------------- */\nbody {\n  background-color: var(--bg-app) !important;\n  color: var(--text-secondary);\n  font-family: var(--font-sans) !important;\n  font-size: var(--fs-base);\n  line-height: var(--lh-normal);\n  letter-spacing: -0.011em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\nbody,\nbutton,\ninput,\nselect,\ntextarea,\n.ant-layout,\n.ant-btn,\n.ant-input,\n.ant-select,\n.ant-menu,\n.ant-table,\n.ant-modal,\n.ant-form,\n.ant-typography {\n  font-family: var(--font-sans) !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.ant-typography h1, .ant-typography h2, .ant-typography h3,\n.ant-page-header-heading-title,\n.ime-display {\n  font-family: var(--font-display) !important;\n  color: var(--text-primary);\n  font-weight: var(--fw-bold);\n  letter-spacing: -0.02em;\n  line-height: var(--lh-tight);\n}\n\na {\n  color: var(--brand-600);\n  transition: color var(--dur-fast) var(--ease-out);\n}\na:hover {\n  color: var(--brand-700);\n}\n\n::selection {\n  background: var(--brand-200);\n  color: var(--brand-900);\n}\n\n.ant-avatar {\n  background: var(--brand-gradient) !important;\n  font-family: var(--font-display) !important;\n  font-weight: var(--fw-semibold);\n}\n\n/* ----------------------------- Scrollbar ----------------------------- */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--n-300) transparent;\n}\n*::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n*::-webkit-scrollbar-thumb {\n  background: var(--n-300);\n  border-radius: var(--r-full);\n  border: 2px solid transparent;\n  background-clip: content-box;\n}\n*::-webkit-scrollbar-thumb:hover {\n  background: var(--n-400);\n  background-clip: content-box;\n}\n\n/* ----------------------------- Focus ring (a11y) ----------------------------- */\na:focus-visible,\nbutton:focus-visible,\n.ant-btn:focus-visible,\n.ant-input:focus-visible,\n.ant-select-selector:focus-visible,\n[tabindex]:focus-visible {\n  outline: 2px solid var(--brand-500);\n  outline-offset: 2px;\n  border-radius: var(--r-sm);\n}\n\n/* =====================================================================\n   Motion library — keyframes + utility classes\n   ===================================================================== */\n@keyframes ime-fade-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n@keyframes ime-fade-in-up {\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes ime-fade-in-down {\n  from { opacity: 0; transform: translateY(-12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes ime-scale-in {\n  from { opacity: 0; transform: scale(0.96); }\n  to   { opacity: 1; transform: scale(1); }\n}\n@keyframes ime-shimmer {\n  0%   { background-position: -468px 0; }\n  100% { background-position: 468px 0; }\n}\n@keyframes ime-spin {\n  to { transform: rotate(360deg); }\n}\n@keyframes ime-pulse {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: 0.5; }\n}\n@keyframes ime-pop {\n  0%   { transform: scale(0.8); opacity: 0; }\n  60%  { transform: scale(1.05); opacity: 1; }\n  100% { transform: scale(1); }\n}\n\n.ime-fade-in      { animation: ime-fade-in var(--dur-base) var(--ease-out) both; }\n.ime-fade-in-up   { animation: ime-fade-in-up var(--dur-slow) var(--ease-out) both; }\n.ime-fade-in-down { animation: ime-fade-in-down var(--dur-slow) var(--ease-out) both; }\n.ime-scale-in     { animation: ime-scale-in var(--dur-base) var(--ease-spring) both; }\n\n.ime-stagger > * {\n  animation: ime-fade-in-up var(--dur-slow) var(--ease-out) both;\n  animation-delay: calc(var(--i, 0) * 60ms);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
